import Alpine from "alpinejs";
import { v4 as uuidv4 } from 'uuid';

const NO_FOUND_EL_ERROR_MSG = "Please enter a valid address in South Australia.";

const SA_BOUNDS = {
	"south": -38.0659,
	"west": 129.0000,
	"north": -25.9960,
	"east": 141.0028
};

function findMember ({reload=true}){
    return{
        address: Alpine.store('global')?.address ??  '',
        lat: Alpine.store('global')?.lat ??  '',
        lng: Alpine.store('global')?.lng ??  '',
        foundaddress:false,
        error:false,
        errorMsg:'',
        reload: reload,
       async init() {
            const sessionToken =  uuidv4(); // generate session token
            // Refactored to google maps
            await this.initializeAutocomplete();
            if(Alpine.store("global")?.address != ''){
                this.foundaddress = true
            }
            this.$watch("Alpine.store('global')?.address", async (address) => {
                if(address != ''){
                   this.address =  address;
                }
            });
        },
        async  initializeAutocomplete() {
            await google.maps.importLibrary("places");
            // Get the input element
            const input = document.getElementById("customautocomplete");
            if (!input) {
                console.error("Input element with ID 'custom-autocomplete' not found.");
                return;
            }
            // Initialize Autocomplete on the input element
            const autocomplete = new google.maps.places.Autocomplete(input, {
                types: ["street_address" ,"administrative_area_level_1" ,  "sublocality", "locality", "postal_code"], 
                bounds: SA_BOUNDS,
                strictBounds: true,
                componentRestrictions:  { country: "au" },
            });
            // Add listener for place selection
            autocomplete.addListener("place_changed", () => {
                try {
                const place = autocomplete.getPlace();

                if (!place.place_id) {
                    this.error  = true;
                    this.errorMsg = NO_FOUND_EL_ERROR_MSG
                    return;
                }
                this.foundaddress = true;
                const placeLatLng = place.geometry?.location?.toJSON()
                if(placeLatLng.lat && placeLatLng.lng){
                    this.address = place.formatted_address;
                    this.lat = placeLatLng.lat;
                    this.lng =  placeLatLng.lng;

                    // Run submit
                    this.handleSubmit();
                }
                } catch (error) {
                    this.error  = true;
                    this.errorMsg = NO_FOUND_EL_ERROR_MSG;
                    return;
                }
            });
            input.addEventListener('input',(e)=>{
                if(e.target.value == ''){
                    this.error = false;
                    this.errorMsg = "";
                    this.foundaddress = false;
                    this.lat = '';
                    this.lng = '';
                    Alpine.store('global').clearAddress('');
                }
                if (e.target !== e.currentTarget) return;
                let value = e.target.value;
                if(Alpine.store("global")?.address != '' && value && value?.trim() != Alpine.store("global")?.address?.trim()){
                        this.foundaddress = false;
                        this.lat = '';
                        this.lng = '';
                        Alpine.store('global').clearAddress('');
                }
            })
        },
        async clearGloablForm(){
            this.address = '';
            this.lat = '';
            this.lng = '';
            let url = new URL(window.location);
            if(url.searchParams.has('electorate')){
                url.searchParams.delete('electorate');
            }
            window.history.pushState({}, '', url);
            Alpine.store('global').clearAddress('');
        },
        async handleButtonSubmitClick(){
            if(this.foundaddress == false){
                this.error = true;
                this.errorMsg = NO_FOUND_EL_ERROR_MSG
                return;
            }
            await this.handleSubmit();
        },
        async handleSubmit() {
            let searchparams = new URLSearchParams();
            try {
                if(this.lat != '' && this.lng != '' && this.address != ''){
                    const res = await fetch(`api/members?lat=${encodeURIComponent(this.lat)}&lng=${encodeURIComponent(this.lng)}`).then(res=> res.json())
                    if(res?.data?.name){
                        if(this.reload != true){
                            let url = new URL(window.location);
                            url.searchParams.set('electorate',res?.data?.name);
                            url.searchParams.delete('sort'); // remove sort
                            window.history.pushState({}, '', url);
                        }else{
                            searchparams.set('electorate',res?.data?.name);
                            searchparams.delete('sort');
                            window.location.href =  `/members?${searchparams.toString()}`
                        }
                        // Update Global State
                        Alpine.store('global').setAddress(this.address);
                        Alpine.store('global').setLat(this.lat);
                        Alpine.store('global').setLng(this.lng);
                        Alpine.store('global').setElectorate(res?.data?.name);
                        // Remove Eror
                         this.error  = false;
                         this.errorMsg = NO_FOUND_EL_ERROR_MSG

                    }else{
                        this.clearGloablForm()
                    }
                }else{
                   this.clearGloablForm()
                }
            } catch (error) {
                 this.error  = true;
                 this.errorMsg = NO_FOUND_EL_ERROR_MSG
            }
        },
        async handleclear() {
            this.foundaddress = false;
            this.address = '';
            this.lat = '';
            this.lng = '';
            Alpine.store('global').clearAddress('');
        }
    }
}

document.addEventListener('alpine:init', () => {
    // Find Member
    Alpine.data('findMember', findMember );
});